module.exports = __webpack_public_path__ + "static/media/bgi-openscout-devstarXD-7@2x.969b0a64.png";